module.exports = __webpack_public_path__ + "static/img/diqiuyi.054cd59f.svg";